import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ITemplateEntityDTO, TemplateType } from '@modeso/types__aumico-lib-templates-be';
import Debug from 'debug';
import { BaseComponent } from '../../components/base.component';
import { TemplatesProvider } from '../../provider/templates.provider';

const debug = Debug('aumico:aumico-lib-templates-fe:TemplatesListComponent');

@Component({
    selector: 'aumico-templates-list',
    templateUrl: 'templates-list.component.html',
    styleUrls: ['templates-list.component.scss'],
})
export class TemplatesListComponent extends BaseComponent implements OnInit {
    @Input() templatesType: TemplateType;
    @Output() directToTemplatesFormEvent = new EventEmitter();
    templates: ITemplateEntityDTO[];

    constructor(public override templatesProvider: TemplatesProvider) {
        super(templatesProvider);
    }

    override ngOnInit() {
        this.templatesProvider.dispatchTemplates();
        this.templatesProvider.getTemplates$().subscribe((templates: ITemplateEntityDTO[]) => {
            if (templates) {
                this.templates = templates.filter((template) => template.type == this.templatesType);
            }
        });
    }

    addOrUpdateTemplate(templateId?: string) {
        if (templateId) {
            this.templatesProvider.setActiveTemplate(templateId);
        }
        this.templatesProvider.setActiveTemplateType(this.templatesType);
        this.directToTemplatesFormEvent.emit();
    }
}
